import React, { useMemo } from "react";
import { FormatDateStamp } from "../../../utils/dateFormat";
import taskStyle from "../../../assets/css/modules/taskManagement.module.css";
import ReactDataTableWrapper from "../../../customComponents/ReactDataTables/ReactDataTableWrapper";

const getInitials = (name = "") => {
  const initials = name
    .split(/[, ]+/)
    .filter(Boolean)
    .map((n) => n.charAt(0).toUpperCase())
    .join("");
  return initials.length >= 2 ? initials.substring(0, 2) : "";
};

const getTaskColor = (taskType) => {
  switch (taskType?.toLowerCase()) {
    case "coach":
      return "#FFE9A8";
    case "hot topic":
      return "#D7EAFF";
    case "recognize":
    case "recognition":
      return "#CAE9C6";
    case "follow up":
      return "#FECCCD";
    default:
      return "#E7EAED";
  }
};

const Profile = ({ name, title, image, avatar, isSystem = false }) => {
  const initials = getInitials(name);

  return (
    <div className="profile d-flex">
      {isSystem ? (
        <div style={{ paddingRight: "2px" }}>
          <img
            src="/images/amplifai_logo.png"
            className="rouded-circle cus-imgs"
          />
        </div>
      ) : image ? (
        <img
          className={taskStyle.task_manager_image}
          src={`data:image/png;base64,${image}`}
        />
      ) : avatar ? (
        <img className={taskStyle.task_manager_image} src={avatar} />
      ) : (
        <div className={taskStyle.initials_tm}>{initials}</div>
      )}

      <div style={{ padding: "0px 10px 0px 0px" }}>
        <div className="profilename">{isSystem ? "System" : name}</div>
        <div className={taskStyle.prpfilesubtitle}>
          {isSystem ? "Amplifai" : title}
        </div>
      </div>
    </div>
  );
};

const TaskButton = ({ taskType, taskColor }) => (
  <button
    className="btn btn-primary rec"
    style={{
      backgroundColor: taskColor,
      border: `1px solid ${taskColor}`,
      color: "#25282C",
    }}
  >
    {taskType}
  </button>
);

const TaskTable = ({ rowData, mode, onRowClick, onCellClick }) => {
  const {
    getTaskSaveList = [],
    gettaskmanagerlist = [],
    getTaskManagerList1 = [],
  } = rowData || {};

  const rows = useMemo(() => {
    const sortByTaskSaveId = (a, b) =>
      Number(a.taskSaveId) - Number(b.taskSaveId);

    if (mode === "mytasks") {
      const userTasks = getTaskSaveList
        .filter(
          (x) =>
            ![
              "canceled",
              "incomplete",
              "complete",
              "completed",
              "expired",
            ].includes(x.statustype?.toLowerCase()),
        )
        .map((x) => ({
          ...x,
          rowType: "taskSave",
        }));

      const systemTasks = gettaskmanagerlist
        .filter(
          (x) =>
            !["completed", "canceled", "archived", "expired"].includes(
              x.status?.toLowerCase(),
            ),
        )
        .map((x) => ({
          ...x,
          rowType: x.isAIMLGeneratedTask ? "aimlTask" : "systemTask",
        }));

      return [...userTasks, ...systemTasks];
    }

    if (mode === "history") {
      const managerMap = Object.fromEntries(
        gettaskmanagerlist.map((x) => [Number(x.taskSaveId), x]),
      );

      const managerMap1 = Object.fromEntries(
        getTaskManagerList1.map((x) => [Number(x.taskSaveId), x]),
      );

      const userTasks = getTaskSaveList
        .filter((x) =>
          [
            "canceled",
            "incomplete",
            "complete",
            "completed",
            "reopen",
            "viewed",
            "expired",
          ].includes(x.statustype?.toLowerCase()),
        )
        .sort(sortByTaskSaveId)
        .map((item) => {
          let TaskManagerDetails = null;

          if (item.taskType?.toLowerCase().trim() === "coach") {
            TaskManagerDetails = managerMap1[item.taskSaveId];
          } else {
            TaskManagerDetails = managerMap[item.taskSaveId];
          }

          return {
            ...item,
            TaskManagerDetails,
            rowType: "taskSave",
          };
        });

      const systemTasks = gettaskmanagerlist
        .filter(
          (x) =>
            ["completed", "canceled", "archived", "expired"].includes(
              x.status?.toLowerCase(),
            ) && Number(x.taskSaveId) === 0,
        )
        .sort(sortByTaskSaveId)
        .map((x) => ({
          ...x,
          rowType: x.isAIMLGeneratedTask ? "aimlTask" : "systemTask",
        }));

      return [...userTasks, ...systemTasks];
    }
    debugger;
    return [];
  }, [getTaskSaveList, gettaskmanagerlist, getTaskManagerList1, mode]);
  const columns = [
    {
      title: "ID",
      render: (row) => row.taskSaveId || row.recordid,
    },

    {
      title: "From",
      render: (row) => (
        <Profile
          name={row.createdByName || row.fromname}
          title={row.createdByTitle || row.fromtitle}
          image={row.createduserimage}
          avatar={row.createdavtarimage}
        />
      ),
    },

    {
      title: "Task",
      render: (row) => {
        const taskType = row.tasktype || row.taskType;
        const taskColor = row.taskcolor || getTaskColor(taskType);

        return (
          <TaskButton
            taskType={row.taskLabelTM || taskType}
            taskColor={taskColor}
          />
        );
      },
    },

    {
      title: "User",
      render: (row) => (
        <Profile
          name={row.userName || row.username}
          title={row.usertitle || row.createdToTitle}
          image={row.createdtouserimage || row.userImage}
          avatar={row.createdtoavtarimage || row.avatarImage}
        />
      ),
    },

    {
      title: "Metric",
      render: (row) => row.metricName || row.metricname || "",
    },

    {
      title: "Created",
      render: (row) => FormatDateStamp(row.createdDate || row.createddate),
    },

    {
      title: "Status",
      render: (row) => row.taskstatus || row.status,
    },

    {
      title: "Reference ID",
      render: (row) => row.referenceId || row.referenceid,
    },

    {
      title: "Ack Date",
      render: (row) => {
        const taskType = row.tasktype || row.taskType;

        if (
          (row.acknowledgeDate || row.AcknowledgeDate) &&
          taskType?.toLowerCase() === "follow up"
        ) {
          return new Date(
            row.acknowledgeDate || row.AcknowledgeDate,
          ).toLocaleDateString("en-US");
        }

        return "";
      },
    },
  ];

  return (
    <ReactDataTableWrapper
      columns={columns}
      data={rows}
      options={{
        lengthMenu: [10, 25, 50, 100],
        paging: true,
        pageLength: 10,
        lengthChange: true,
        searching: true,
        info: false,
        scrollY: "40vh",
      }}
      onRowClick={onRowClick}
      onCellClick={onCellClick}
      // onRowClick={(row) => {
      //   console.log("Row clicked", row);
      // }}
    />
  );
};

export default TaskTable;
